import { LanguageEnum, LocationType, ServiceType } from '@/types';
import { PATH } from '@/data';
import { __ServiceInfo } from './serviceInfo.lang';

export const __ServiceDetailBreadcrumbData = (
    lang: typeof __ServiceInfo,
    language: LanguageEnum,
    location: LocationType<'detail'>,
    data: ServiceType,
) => [
    { title: lang.tehranto, href: PATH(language).home() },
    { title: location.name, href: PATH(language).location(location.slug) },
    { title: lang.services, href: PATH(language).services.index(location.slug) },
    { title: data.title, href: PATH(language).services.detail(data) },
];
